var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_5763)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1215_5763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L27 66.8429ZM27 66.8429C35.8757 59.2569 42.4947 52.2272 46.8794 45.7461C51.3183 39.185 53.5 33.1679 53.5 27.675C53.5 19.3532 50.826 12.7748 45.5173 7.87517C40.1802 2.95355 34.0117 0.5 27 0.5C19.9883 0.5 13.8197 2.95359 8.48252 7.8753L27 66.8429Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1176 18.2346C20.5294 18.2346 20.0245 18.0267 19.6029 17.611C19.1814 17.1952 18.9706 16.6974 18.9706 16.1173C18.9706 15.5372 19.1814 15.0393 19.6029 14.6236C20.0245 14.2079 20.5294 14 21.1176 14C21.7059 14 22.2108 14.2079 22.6324 14.6236C23.0539 15.0393 23.2647 15.5372 23.2647 16.1173C23.2647 16.6974 23.0539 17.1952 22.6324 17.611C22.2108 18.0267 21.7059 18.2346 21.1176 18.2346ZM33.9118 24.8184C33.4216 24.8184 33.0049 24.6492 32.6618 24.3108C32.3186 23.9725 32.1471 23.5616 32.1471 23.0782C32.1471 22.5948 32.3186 22.1839 32.6618 21.8455C33.0049 21.5071 33.4216 21.338 33.9118 21.338C34.402 21.338 34.8186 21.5071 35.1618 21.8455C35.5049 22.1839 35.6765 22.5948 35.6765 23.0782C35.6765 23.5616 35.5049 23.9725 35.1618 24.3108C34.8186 24.6492 34.402 24.8184 33.9118 24.8184ZM19.0588 37V28.5889H17V21.338C17 20.8546 17.1716 20.4437 17.5147 20.1053C17.8578 19.7669 18.2745 19.5977 18.7647 19.5977H23.2353C23.5686 19.5977 23.8775 19.6847 24.1618 19.8588C24.4461 20.0328 24.6667 20.2745 24.8235 20.5839L28.8235 28.6469L30.9706 26.3846C31.0882 26.2493 31.2304 26.1477 31.3971 26.0801C31.5637 26.0124 31.7353 25.9786 31.9118 25.9786H35.7059C36.0588 25.9786 36.3627 26.1042 36.6176 26.3556C36.8725 26.607 37 26.9067 37 27.2547V32.0694H35.5294V37H31.4118V28.2119L29.6765 30.0391H27.6176L23.7647 22.4111V37H19.0588Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1215_5763",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1215_5763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1215_5763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_5763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq19);
export default __webpack_public_path__ + "static/media/pin-eq-19.eeef8bed5c74019578e60aa6049144b7.svg";
export { ForwardRef as ReactComponent };